import template from './categorizeIncomingDocument.html';
import { CategorizeIncomingDocumentController } from './categorizeIncomingDocument.controller';

export const categorizeIncomingDocumentComponent = {
  name: 'categorizeIncomingDocumentComponent',
  restrict: 'E',
  template,
  controller: CategorizeIncomingDocumentController,
  controllerAs: 'vm',
  bindings: {
    ibans: '=',
    form: '='
  }
};
